<script>
export default {
  name: 'AdSettingsForm',
  components: {},
  props: {
    value: { type: Object, required: true }
  },
  data() {
    return {
      formData: this.value
    }
  },
  methods: {
    update(field, value) {
      this.formData[field] = value
      this.$emit('input', this.formData)
    }
  },
  watch: {
    value: function(oldValue, newValue) {
      this.formData = newValue
    }
  }
}
</script>

<template>
  <v-form></v-form>
</template>
